$(document).on('click touch', '*[data-scroll-with-offset]', function() {
    let arr = $(this).attr('data-scroll-with-offset').split(' '),
        target = arr[0],
        resRatio = arr[2],
        additionalOffset,
        targetOffsetTop = $('#' + target).offset().top,
        hH = $('.main-header__sticky-wrapper').outerHeight(),
        sideTabsH = $('.js-side-tabs').outerHeight(),
        finalOffset,
        res = resolutionCheck();

    if (
        // scroll up
        $(this)
        .closest('.js-scroll-btn-parent')
        .siblings()
        .find('.js-scroll-btn.active')
        .closest('.js-scroll-btn-parent')
        .index() > $(this).closest('.js-scroll-btn-parent').index()
    ) {
        if (res < 120) {
            additionalOffset = sideTabsH;
            finalOffset = parseInt(targetOffsetTop - hH - additionalOffset);
        } else {
            additionalOffset = arr[1];
            // finalOffset = parseInt(targetOffsetTop - hH / 0.5 - additionalOffset);
            finalOffset = parseInt(targetOffsetTop - hH);
        }
    } else if (
        // scroll down
        $(this)
        .closest('.js-scroll-btn-parent')
        .siblings()
        .find('.js-scroll-btn.active')
        .closest('.js-scroll-btn-parent')
        .index() < $(this).closest('.js-scroll-btn-parent').index()
    ) {
        if (res < 120) {
            additionalOffset = sideTabsH;
        } else {
            additionalOffset = 0;
        }
        // finalOffset = parseInt(targetOffsetTop - additionalOffset);
        finalOffset = parseInt(targetOffsetTop - additionalOffset);
    }

    $('html, body').animate({ scrollTop: finalOffset }, 250);
});

const setMinHeightOfScrolledSectionsWrap = () => {
    if ($('.js-side-tabs').length) {
        let res = resolutionCheck(),
            sideMenu = $('.js-side-tabs'),
            sideMenuHeight = sideMenu.outerHeight(),
            sectionsWrap = $('.js-scrolled-sections-wrap');
        if (res > 76) {
            sectionsWrap.css('min-height', sideMenuHeight + 128 + 'px');
        } else {
            sectionsWrap.css('min-height', '0');
        }
    }
};
$(window).on('load resize orientationchange', function() {
    setMinHeightOfScrolledSectionsWrap();
});
